export default __webpack_public_path__ + "static/media/error.353ce7ad.mp3";